import React, { useState } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { axios } from '../../services/axios';
import swal from 'sweetalert2';

const CreateMenuTypeModal = ({ isOpen, toggle, onSuccess }) => {
  const [formData, setFormData] = useState({
    en: { name: '' },
    ar: { name: '' },
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e, locale) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [locale]: {
        ...prev[locale],
        name: value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axios.post('/menu-types', formData);
      swal.fire({
        title: 'Success',
        type: 'success',
        text: 'Menu type created successfully!',
        timer: 3000,
      });
      onSuccess();
    } catch (error) {
      console.error('Error creating menu type:', error);
      swal.fire({
        title: 'Error',
        type: 'error',
        text: error.response?.data?.message || 'Failed to create menu type',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Create Menu Type</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label>Name (English)</Label>
            <Input
              type='text'
              name='name'
              value={formData.en.name}
              onChange={(e) => handleChange(e, 'en')}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Name (Arabic)</Label>
            <Input
              type='text'
              name='name'
              value={formData.ar.name}
              onChange={(e) => handleChange(e, 'ar')}
              required
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            Cancel
          </Button>
          <Button color='primary' type='submit' disabled={loading}>
            {loading ? 'Creating...' : 'Create'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default CreateMenuTypeModal;
